<template>
  <div class="modal-container">
    <b-modal
      ignore-enforce-focus-selector=".header"
      modal-class="padding-top_modal-form"
      hide-header
      hide-footer
      dialog-class="app__settings-modal"
      :body-class="{ modal_body: !isMobile}"
      content-class="modal_content"
      id="settings">
      <settings-form/>
    </b-modal>
    <b-modal
      ignore-enforce-focus-selector=".header"
      modal-class="padding-top_modal-form"
      hide-header
      hide-footer
      dialog-class="app__settings-modal"
      body-class="modal_body"
      content-class="modal_content"
      id="cropper"
    >
      <app-cropper
        :src="cropperInfo.src"
        :dispatch-action="cropperInfo.dispatchAction"
        :dispatch-data="cropperInfo.dispatchData"
        :reload-events="cropperInfo.reloadEvents"
      />
    </b-modal>
    <b-modal
      ignore-enforce-focus-selector=".header"
      modal-class="padding-top_modal-list"
      hide-header
      hide-footer
      dialog-class="app__add-family-participants-modal"
      body-class="modal_body"
      content-class="modal_content"
      id="user-contact-participants">
      <user-contact-participants-form :lock-user-deletion="true"/>
    </b-modal>
    <b-modal
      ignore-enforce-focus-selector=".header"
      modal-class="padding-top_modal-list"
      hide-header
      hide-footer
      dialog-class="app__add-family-participants-modal"
      body-class="modal_body"
      content-class="modal_content"
      id="add-user-contact-participants">
      <add-user-contact-participants-form
        parent-modal="add-user-contact-participants"
      />
    </b-modal>
    <b-modal
      ignore-enforce-focus-selector=".header"
      modal-class="padding-top_modal-list"
      hide-header
      hide-footer
      dialog-class="app__add-family-participants-modal"
      body-class="modal_body"
      content-class="modal_content"
      id="family-participants">
      <family-participants-form/>
    </b-modal>
    <b-modal
      ignore-enforce-focus-selector=".header"
      modal-class="padding-top_modal-list"
      hide-header
      hide-footer
      dialog-class="app__add-family-participants-modal"
      body-class="modal_body"
      content-class="modal_content"
      id="add-family-participants">
      <add-family-participants-form
        parent-modal="add-family-participants"
      />
    </b-modal>
    <b-modal
      ignore-enforce-focus-selector=".header"
      centered
      hide-footer
      hide-header
      dialog-class="app-confirm-modal"
      body-class="modal_body"
      content-class="modal_content"
      id="app-confirm-modal"
    >
      <confirm-modal-form />
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AppCropper from '../../forms/AppCropper/AppCropper';
import AddUserContactParticipantsForm
  from '../../forms/AddUserContactParticipantsForm/AddUserContactParticipantsForm';
import AddFamilyParticipantsForm
  from '../../forms/AddFamilyParticipantsForm/AddFamilyParticipantsForm';
import FamilyParticipantsForm from '../../forms/FamilyParticipantsForm/FamilyParticipantsForm';
import SettingsForm from '../../forms/SettingsForm/SettingsForm';
import ConfirmModalForm from '../../forms/ConfirmModalForm/ConfirmModalForm';
import UserContactParticipantsForm
  from '../../forms/UserContactParticipantsForm/UserContactParticipantsForm';

export default {
  name: 'HeaderModals',
  components: {
    AppCropper,
    AddUserContactParticipantsForm,
    AddFamilyParticipantsForm,
    FamilyParticipantsForm,
    SettingsForm,
    ConfirmModalForm,
    UserContactParticipantsForm,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      cropperInfo: (state) => state.operations.cropperInfo,
    }),
  },
};
</script>

<style scoped>

</style>
